import type { TDatadogErrorLog } from 'utils/datadog/types'

import type { UsePostsByTerritoryOptions } from './types'

const DEFAULT_LIMIT = 1

export const DEFAULT_OPTIONS: UsePostsByTerritoryOptions = {
  limit: DEFAULT_LIMIT,
}

export const GET_POSTS_BY_TERRITORY_LOG: TDatadogErrorLog = {
  from: 'src/hooks/usePostsByTerritory',
  name: 'Get posts by territory',
  message: 'Error fetching posts by territory',
}
